import { useState } from 'react';
import ComplianceDashboardPage from './ComplianceDashboardPage';
import ComplianceItemsPage from './ComplianceItemsPage';
import ComplianceTemplatesPage from './ComplianceTemplatesPage';
import ComplianceCategoriesPage from './ComplianceCategoriesPage';
import AuditLogPage from './AuditLogPage';

const TABS = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'items', label: 'Items' },
  { key: 'templates', label: 'Templates' },
  { key: 'categories', label: 'Categories' },
  { key: 'audit', label: 'Audit Log' },
];

export default function CompliancePage() {
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <div>
      {/* Tab bar */}
      <div style={{
        display: 'flex', gap: 0, borderBottom: '2px solid #e2e8f0',
        padding: '0 24px', background: '#fff', position: 'sticky', top: 0, zIndex: 10,
      }}>
        {TABS.map(tab => {
          const isActive = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              style={{
                padding: '14px 20px', border: 'none', cursor: 'pointer',
                fontSize: 13, fontWeight: isActive ? 800 : 600,
                color: isActive ? '#6d28d9' : '#64748b',
                background: 'transparent',
                borderBottom: isActive ? '3px solid #6d28d9' : '3px solid transparent',
                marginBottom: '-2px',
                transition: 'all 0.15s',
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab content */}
      {activeTab === 'dashboard' && <ComplianceDashboardPage />}
      {activeTab === 'items' && <ComplianceItemsPage />}
      {activeTab === 'templates' && <ComplianceTemplatesPage />}
      {activeTab === 'categories' && <ComplianceCategoriesPage />}
      {activeTab === 'audit' && <AuditLogPage />}
    </div>
  );
}
